<template>
  <div class="main">
    <div class="welcome"></div>

    <div class="carousel-about">
      <el-carousel class="carousel">
        <el-carousel-item v-for="item in carousel" :key="item">
          <img :src="item" class="carousel-img">
        </el-carousel-item>
      </el-carousel>
      <!--      <div class="about-us">
              <ColumnTitle title="About us" title-color="white" split-line-color="white"></ColumnTitle>
              <p class="text">We are a research team leading by Prof. Wei Chen at the University of Science and Technology of
                China (USTC)
                Applied Chemistry department. Our research goal is to develop new materials and technologies for advanced
                energy
                storage and production applications.</p>
            </div>-->
    </div>
    <div class="content">
      <column-title title="Publications" link="/Publications"></column-title>
      <Publication v-for="(pub,index) in publications.slice(0,5)" :key="pub.title" v-bind="pub">
        {{ publications.length - index }}.&nbsp;
      </Publication>
      <column-title title="News&Events" link="/News"></column-title>
      <el-timeline class="event">
        <el-timeline-item v-for="(event,index) in events.slice(0,5)" :key="index" :timestamp="event.time"
                          placement="top">
          <p>{{ event.event }}</p>
        </el-timeline-item>
      </el-timeline>
    </div>

  </div>
</template>

<script>
import carousel1 from '@/assets/images/Cover1-group2020.jpg';
import carousel2 from '@/assets/images/Cover2.jpg';
import carousel3 from '@/assets/images/Cover3.jpg';
import publications from "@/assets/data/publications";

import ColumnTitle from "@/components/ColumnTitle";
import Publication from "@/components/Publication";
import event from "@/assets/data/event";

export default {
  name: "Home",
  components: {
    ColumnTitle,
    Publication
  },
  data() {
    return {
      carousel: [
        carousel1,
        carousel2,
        carousel3
      ],
      events: event,
      publications
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  padding-top: 1px;
  min-height: calc(100% - 60px)
}

.welcome {
  color: #0094ff;
  font-size: 32px;
  font-weight: bold;
  padding: 8px;
}

.carousel-about {
  background-color: #efefef;
}

.carousel-card {
  width: 60%;
  margin: 32px 0;
  border-radius: 10px;
}

.carousel-about {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.carousel {
  height: 40vw;
  width: 80vw;
}


.carousel-about::v-deep(.el-carousel__container) {
  height: 40vw;
  width: 80vw;
}

.carousel-about::v-deep(.el-carousel__item) {
  width: 80vw;
  height: 40vw;
}

.about-us {
  width: 30vw;
  height: 25vw;
}


.carousel {
  display: inline-block;
}

.carousel-img {
  width: 100%;
  height: 100%;
}

.about-us {
  display: inline-block;
  box-sizing: border-box;
  background-color: #0094ff;
  color: white;
  padding: 32px;
}

.about-us .text {
  color: #d8f0ff;
}

.content {
  width: 80%;
  margin: auto;
}

.column-split-line {
  background: white;
  height: 4px;
  width: 40px;
}

.event {
  font-size: 16px;
}

.text {
  line-height: 24px;
}

</style>